import { useRef, useState } from "react";
import { Map, MapMarker } from "react-kakao-maps-sdk";

export default function MapKakao(){
  const location = { lat: 35.875997, lng: 128.477158};
  const mapRef = useRef();
  const [state, setState] = useState({center:location, isPanto:true});

  const handleCenter = ()=>{
    setState({center:location, isPanto:true});
  }

  return (
    <>
      <Map
        ref={mapRef}
        className="w-[300px] h-[300px] lg:w-[700px] lg:h-[360px]"
        center={state.center}
        isPanto={state.isPanto} >
        <MapMarker position={location} title="SJ Energy"/>
      </Map>
      <button onClick={()=>handleCenter()}>Center</button>
    </>
  );

}